import PropTypes from 'prop-types';
import currencyShape from './currency';

export default PropTypes.arrayOf(
  PropTypes.shape({
    pnr: PropTypes.string,
    amount: PropTypes.number,
    currency: currencyShape,
    status: PropTypes.string
  })
);
